import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=03406870&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=ts&"
export * from "./PageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=03406870&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03406870",
  null
  
)

export default component.exports